import styled from "styled-components";

export const StyledDiagnostics = styled.div<{ $height: number }>`
  position: relative;
  background-color: var(--color-background);
  height: ${({ $height }) => `${$height}px`};
  overflow: hidden;
`;
